// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__ID5Dt","link":"HeaderSimple_link__43LKw","inputSearch":"HeaderSimple_inputSearch__kcJ3d"};